// extracted by mini-css-extract-plugin
module.exports = {"packshot":"_3I7QY7","seasonPackshot":"_1OZAOp","packshotRedesign":"_3AaXaE","seasonPackshotRedesign":"dY9sXU","imageWrapper":"QwOlZO"};